export default __webpack_public_path__ + "static/media/addOnBenefitshelpMobileHighlight.6e8bb57b.png";